<adapt-styled-dashboard-element #dashboardElement
                                [name]="category.name"
                                [nested]="true"
                                [isCollapsible]="true"
                                [iconClass]="!isOrganisationProduct ? 'fas fa-grip-dots-vertical ps-3 card-drag-handle' : undefined">
    @if (isOrganisationProduct) {
        <div adapt-collapsible-header-title
             class="d-flex align-items-center ms-2">
            <adapt-progress-bar class="progress-bar"
                                [percentageProgress]="progressPercent"
                                [adaptTooltip]="progressText"
                                [adaptTooltipIsHtml]="true"
                                [colour]="ProgressItemStatusMeta[ProgressItemStatus.Done].colour"></adapt-progress-bar>
        </div>
    }

    <div adapt-collapsible-header-action-right
         class="d-flex align-items-center">
        @if (canEdit && autoSave) {
            <adapt-autosave #autosaveComponent
                            [class.d-none]="dashboardElement.collapsed"></adapt-autosave>
        }

        @if (!isOrganisationProduct && canEdit) {
            <div class="card-header-buttons p-2"
                 adaptBlockingButtonGroup>
                @if (!autoSave) {
                    <button adaptButton="save"
                            [disabled]="entitiesAreUnmodifiedOrInvalid"
                            [enableButtonOnFinalize]="false"
                            [adaptBlockingClick]="save"
                            [stopPropagation]="true"></button>
                    <button adaptButton="cancel"
                            [disabled]="entitiesAreUnmodified"
                            [enableButtonOnFinalize]="false"
                            [adaptBlockingClick]="cancel"
                            [stopPropagation]="true"></button>
                }
                <button class="ms-2"
                        adaptButton="edit"
                        (click)="categoryEdit.emit(category); $event.stopPropagation()">category</button>
                <button class="ms-2"
                        adaptButton="delete"
                        (click)="categoryDelete.emit(category); $event.stopPropagation()">category</button>
            </div>
        }
    </div>

    <div class="progress-table"
         [ngClass]="{ 'm-2 mt-0': !isOrganisationProduct }"
         [style.--product-accent]="categoryColour"
         data-test="progress-table">
        <dx-scroll-view direction="both">
            <div class="progress-table-header progress-table-row">
                @if (canEdit) {
                    <div class="progress-table-cell progress-table-cell-action text-center"></div>
                }
                <div class="progress-table-cell progress-table-cell-editable progress-table-cell-task flex-grow-1 text-center">Task</div>
                @if (isOrganisationProduct) {
                    <div class="progress-table-cell progress-table-cell-editable progress-table-cell-fixed-picker text-center">Status</div>
                    <div class="progress-table-cell progress-table-cell-editable progress-table-cell-fixed-date text-center">Date</div>
                    <div class="col-3 col-md-4 progress-table-cell text-center">Comments</div>
                }
                @if (canEdit) {
                    <div class="progress-table-cell progress-table-cell-action"></div>
                }
            </div>
            <div class="progress-table-body">
                <dx-sortable handle=".card-drag-handle"
                             [data]="progressItems"
                             [moveItemOnDrop]="true"
                             [allowReordering]="canEdit"
                             (onReorder)="onReorder($event)">
                    @for (item of progressItems; track item.progressItemId) {
                        <div class="progress-table-row d-flex"
                             data-test="progress-table-row">
                            @if (canEdit) {
                                <div class="progress-table-cell progress-table-cell-action d-flex align-items-center">
                                    <div class="card-drag-handle dx-list-item-after-bag dx-list-reorder-handle-container">
                                        <div class="dx-list-reorder-handle"></div>
                                    </div>
                                    @if (!isOrganisationProduct) {
                                        <div>{{ item.ordinal + 1 }}</div>
                                    }
                                </div>
                            }
                            <div class="progress-table-cell progress-table-cell-task flex-grow-1"
                                 [class.progress-table-cell-editable]="canEdit"
                                 data-test="progress-table-cell-task">
                                @if (canEdit) {
                                    <dx-text-box #textBox
                                                 [value]="item.name"
                                                 (onValueChanged)="onTextBoxChange(item, $event)"
                                                 stylingMode="underlined"
                                                 [adaptValidateEntity]="item"
                                                 adaptValidateEntityProperty="name"
                                                 (click)="textBox.instance.focus()"
                                                 (onEnterKey)="autosaveComponent?.triggerSave(entitiesToConfirm); $event.component.blur()"
                                                 (onContentReady)="onTextBoxContentReady($event, item)"></dx-text-box>
                                } @else {
                                    <span>{{ item.name }}</span>
                                }
                            </div>
                            @if (isOrganisationProduct) {
                                <div class="progress-table-cell progress-table-cell-fixed-picker progress-table-cell-status"
                                     [class.progress-table-cell-editable]="canEdit"
                                     [style.background-color]="ProgressItemStatusMeta[item.status].colour"
                                     data-test="progress-table-cell-status">
                                    @if (canEdit) {
                                        <div class="h-100"
                                             (click)="focusOnClick(selectBox)">
                                            <dx-select-box #selectBox
                                                           [items]="ProgressItemStatuses"
                                                           [value]="item.status"
                                                           (onValueChanged)="onSelectBoxChange(item, $event)"
                                                           displayExpr="name"
                                                           valueExpr="status"
                                                           itemTemplate="itemTemplate"
                                                           stylingMode="filled">
                                                <div *dxTemplate="let selectItem of 'itemTemplate'"
                                                     class="d-flex align-items-center">
                                                    {{ selectItem.name }}
                                                    <i class="ms-auto fas fa-circle"
                                                       [style.color]="selectItem.colour"></i>
                                                </div>
                                            </dx-select-box>
                                        </div>
                                    } @else {
                                        <span>{{ ProgressItemStatusMeta[item.status].name }}</span>
                                    }
                                </div>
                                <div class="progress-table-cell progress-table-cell-fixed-date"
                                     [class.progress-table-cell-editable]="canEdit"
                                     data-test="progress-table-cell-date">
                                    @if (canEdit) {
                                        <div class="h-100"
                                             (click)="focusOnClick(dateBox)">
                                            <dx-date-box #dateBox
                                                         [value]="item.date"
                                                         (onValueChanged)="onDateBoxChange(item, $event)"
                                                         [showClearButton]="!!item.date"
                                                         [showDropDownButton]="!item.date"
                                                         applyValueMode="instantly"
                                                         stylingMode="underlined"></dx-date-box>
                                        </div>
                                    } @else {
                                        <span>{{ item.date | adaptDate }}</span>
                                    }
                                </div>
                                <div class="col-3 col-md-4 progress-table-cell progress-table-cell-comment d-flex align-items-start gap-2"
                                     data-test="progress-table-cell-comment">
                                    @if (item.comment) {
                                        <adapt-see-more class="d-block flex-grow-1"
                                                        [maxHeight]="80"
                                                        [stopPropagation]="true">
                                            <div [froalaView]="item.comment"></div>
                                        </adapt-see-more>
                                    } @else if (canEdit) {
                                        <div class="comment-placeholder can-edit flex-grow-1"
                                             (click)="editItemComment(item).subscribe()">Click to add comment...</div>
                                    } @else {
                                        <div class="comment-placeholder flex-grow-1">No comment recorded yet</div>
                                    }
                                    @if (canEdit) {
                                        <button adaptButton="editLink"
                                                class="text-primary"
                                                [class.invisible]="!item.comment"
                                                adaptTooltip="Click to edit comment"
                                                (click)="editItemComment(item).subscribe()"></button>
                                    }
                                </div>
                            }
                            @if (canEdit) {
                                <div class="progress-table-cell progress-table-cell-action d-flex align-items-start justify-content-center">
                                    <button adaptButtonIcon="delete"
                                            adaptTooltip="Delete this task"
                                            [adaptBlockingClick]="deleteProgressItem"
                                            [adaptBlockingClickParam]="item"
                                            [unsubscribeOnDestroy]="false"
                                            class="btn btn-link text-danger"
                                            data-test="progress-table-row-delete"></button>
                                </div>
                            }
                        </div>
                    }

                    @if (canEdit) {
                        <div class="progress-table-row progress-table-row-add-new d-flex"
                             (click)="createNewProgressItem(category).subscribe()"
                             data-test="progress-table-add-new">
                            <div class="progress-table-cell progress-table-cell-action"></div>
                            <div class="col progress-table-cell">+ Add new task</div>
                        </div>
                    }
                </dx-sortable>
            </div>
        </dx-scroll-view>
    </div>
</adapt-styled-dashboard-element>
